// ABOUTME: Route for /dashboard/conversation/:conversationId — read-only conversation viewer
import { ConversationViewerPage } from "@/components/dashboard/ConversationViewerPage";
import { createFileRoute } from "@tanstack/react-router";

interface ConversationSearchParams {
  userName?: string;
}

export const Route = createFileRoute(
  "/_authenticated/dashboard/conversation/$conversationId",
)({
  validateSearch: (
    search: Record<string, unknown>,
  ): ConversationSearchParams => ({
    userName: (search.userName as string) || undefined,
  }),
  component: ConversationViewerPage,
});
